export const validateFileSize = (file: File) => {
  const maxSize = 500 * 1024 * 1024 // 500MBの上限サイズ
  if (file.size > maxSize) {
    return false
  }
  return true
}
export const validateImportFileSize = (file: File) => {
  const maxSize = 800 * 1024 * 1024 // 800MBの上限サイズ
  if (file.size > maxSize) {
    return false
  }
  return true
}
